import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'账户类型',
            prop:'belongToType',
            align:'center',
            headerAlign:'center',
            width:100,
            tooltip:true,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.accountTypeList
                for(var i in list){
                   if(params.row.belongToType*1 == list[i].val*1){
                      text = list[i].title
                      color = list[i].color
                   }
                }
                console.log()
                return h('span',{style:{color:color}},text)
            }
        },
        {
            label:'账号',
            prop:'account',
            align:'left',
            headerAlign:'left',
            tooltip:true,
            width:160
        },
        {
            label:'账户名称',
            prop:'belongToName',
            align:'left',
            headerAlign:'left',
            tooltip:true,
            width:200
        },
        {
            label:'省/市/区县',
            prop:'areaAddress',
            align:'left',
            headerAlign:'left',
            tooltip:true,
            width:300
        },
        {
            label:'详细地址',
            prop:'address',
            align:'left',
            headerAlign:'left',
            tooltip:true,
            width:300,
            render: (h, params) => {
                return h ('span', {}, !params.row.address ? "--":params.row.address)
            }
        },
       
        {
            label:'钱包余额',
            prop:'rechargeBalance',
            align:'center',
            headerAlign:'center',
            width:120,
            render: (h, params) => {
                return h ('div', {}, params.row.rechargeBalance+"元")
            }
        },
        {
            label:'赠送余额',
            prop:'giveBalance',
            align:'center',
            headerAlign:'center',
            width:120,
            render: (h, params) => {
                return h ('div', {}, params.row.giveBalance+"元")
            }
        },
        {
            label:'创建时间',
            prop:'createTime',
            align:'left',
            headerAlign:'left',
            width:180
            
        },
        {
			label: '操作',
			fixed: 'right',
			align: "center",
			headerAlign: "center",
			width: 120,
			render: (h, params) => {
                const recharge = (h) => {
					return h('el-button', {
						props: {
							type: 'text',
						},
						style: {
							padding: 0,
						},
						on: {
							click: () => {
								vm.rechargeBtn(params.row);
							}
						}
					},"充值");
				};
				const look = (h) => {
					return h('el-button', {
						props: {
							type: 'text',
						},
						style: {
							padding: 0,
                            color:"#606266"
						},
						on: {
							click: () => {
								vm.lookBtn(params.row);
							}
						}
					},"查看");
				};
				let bottons = [];
                bottons.push(recharge(h))
				bottons.push(look(h))
				return h('div', {}, bottons);
			}
		}
    ]
}